module.exports = __webpack_public_path__ + "img/lenovo-ideapad-120s-14iap-81a5_1.cb201ebb.jpg";